export type CommentType = 'question' | null;

export enum CommentAttachmentType {
  localizedStrings = "localizedStrings",
  form = "form"
}

export interface CommentAttachment {
  type: CommentAttachmentType;
  [propName: string]: any;
}
